import { useCallback } from "react";

import { Icon, Item, Listbox, Span } from "@icg360/design-system";

import { AddPolicy } from "components/add-policy";
import { usePoliciesList, usePolicyPlatformId } from "data/ss-data-hooks";

import styles from "./mobile-policy-selector.module.scss";

type MobilePolicySelectorProps = {
  onClose: () => void;
};

export const MobilePolicySelector = ({
  onClose,
}: MobilePolicySelectorProps) => {
  const selectedPolicyId = usePolicyPlatformId();
  const { data } = usePoliciesList();

  const onSelectionChange = useCallback(
    (selection: Set<string>) => {
      onClose();
      const selectedPolicyId = selection.keys().next().value;
      const selectedPolicy = data?.find(
        ({ platformPolicyId }) => platformPolicyId === selectedPolicyId,
      );
      if (selectedPolicy) {
        const policyUrl = new URL(window.location.href);
        policyUrl.searchParams.set("policyId", selectedPolicy.keystonePolicyId);
        window.location.assign(policyUrl);
      }
    },
    [onClose, data],
  );

  return data && selectedPolicyId ? (
    <div className={styles.policySelector}>
      <Listbox
        selectedKeys={new Set([selectedPolicyId])}
        selectionMode="single"
        onSelectionChange={onSelectionChange}
        className={styles.selectorBoxDS}
        aria-label="policies"
      >
        {data.map((policy) => {
          const { propertyAddress, platformPolicyId, isCommercial } =
            policy ?? {};
          const selected = platformPolicyId === selectedPolicyId;
          return (
            <Item
              key={platformPolicyId}
              textValue={`${propertyAddress?.street1} ${propertyAddress?.street2} policy number ${platformPolicyId}`}
            >
              <div className={styles.policy}>
                <Icon name={isCommercial ? "Store" : "Home"} />
                <div className={styles.address}>
                  <Span color={selected ? "inverse" : "default"} bold>
                    {propertyAddress?.street1}
                  </Span>
                  {propertyAddress?.street2 ? (
                    <Span color={selected ? "inverse" : "default"} bold>
                      {propertyAddress?.street2}
                    </Span>
                  ) : null}
                  {`(Policy #${platformPolicyId})`}
                </div>
              </div>
            </Item>
          );
        })}
      </Listbox>
      <div className={styles.addPolicyLink}>
        <AddPolicy />
      </div>
    </div>
  ) : null;
};
